angular.module("Main").controller("BookingTerminSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$localStorage", "$window", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $localStorage, $window, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            //unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        //vm.currentUser = SessionService.getUserData();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = false;
        vm.isTermin = true;
        vm.isPayment = false;
        vm.isPayPal = false;

        if (!SessionService.getSessionId()) {
            $state.go("angebot", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            let userData = $localStorage.user;
            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                vm.dataMeeting = {
                    OrderNr: $stateParams.oid,
                    Name: vm.status.artikel,
                    PreisZahl: vm.status.preis,
                    Day: vm.status.start,
                    End: vm.status.ende,
                    PersonNr: vm.status.personNr,
                    RessourcenIds: vm.status.ressourcesIds,
                    TerminNr: vm.status.terminNr,
                    RessourcenartenIds: vm.status.RessourcenartenIds
                };
                if (vm.status.bezahlung === 3 && vm.status.preis > 0) {
                    vm.isPayment = true;
                }
                if (!status.confirmed && status.status !== "ERROR") {
                    if ($state.is("booking_success")) {
                        //Könnte in node direkt nach booking create aufgerufen werden
                        let arrRessourcenartenIds = JSON.parse(vm.dataMeeting.RessourcenartenIds);
                        let idsArten = arrRessourcenartenIds.map(Number)
                        BookingService.confirmReservation($stateParams.oid, $translate.use(), arrRessourcenartenIds).then(function (data) {
                            vm.captured = true;
                            getDataForConfirm();
                            vm.zahlmethode = vm.status.Zahlmethode;
                            if ((data && !_.isEmpty(data.rechnungsNr))) {
                                vm.dataMeeting.RechnungsNr = data.rechnungsNr;
                            }
                            if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                                vm.dataMeeting.RechnungsNr = data.data.rechnungsNr;
                            }
                            BookingService.saveAppointmentHistory(vm.dataMeeting.TerminNr, 8, 5, {s3Nr: userData.uid});
                        }).catch(function (error) {
                            $state.go("booking_termin_error", {
                                cid: SessionService.getAuthData(),
                                message: error.message,
                                id: SessionService.getAuthIdData(),
                                oid: $stateParams.oid
                            });
                            vm.hasError = true;
                        })
                    }
                } else if (status.status === "SUCCESS") {
                    vm.zahlmethode = vm.status.Zahlmethode;
                    vm.dataMeeting.RechnungsNr = vm.status.RechnungsNr;
                    vm.dataMeeting.BookingNr = vm.status.BookingNr;
                    vm.meetingData = vm.dataMeeting;
                    getDataForConfirm();
                }
            });

            vm.remindLocalePayment = $stateParams.locale;
        }

        function getDataForConfirm() {
            vm.personNr = vm.dataMeeting.PersonNr;
            let userData = $localStorage.user;
            BookingService.getUserDetails(userData.uid).then(function (data) {
                vm.memberNr = vm.personNr;
                vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
                vm.isLoggedIn = !_.isNil(userData) && !_.isUndefined($localStorage.user.username);
                vm.member = $localStorage.user;
                vm.member.firstname = $localStorage.user.Firstname;
                vm.member.lastname = $localStorage.user.Lastname;
                vm.member.email = $localStorage.user.Email;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                var arr = JSON.parse(vm.dataMeeting.RessourcenIds);
                var ids = arr.map(Number)
                BookingService.getResourceNames(ids).then(function (data) {
                    vm.MitarbeiterRessource = _.join(_.map(_.sortBy(_.filter(data, {Mitarbeiter: 1}), 'Bezeichnung'), "Bezeichnung"), ", ");
                    vm.NichtMitarbeiterRessource = _.sortBy(_.filter(data, {Mitarbeiter: 0}), 'Bezeichnung');

                }).then(function () {
                    vm.meetingData = vm.dataMeeting;
                    let end = vm.meetingData.End;
                    let timeEnd = moment(vm.meetingData.End).format("HH:mm");
                    if (timeEnd === '00:00') {
                        let newEnd = moment(end).subtract('minutes', 1).format();
                        vm.meetingData.End = new Date(newEnd);
                    }
                })
            });
        }

        //Wird schon in dem confirm Endpoint gemacht

        function bookIntoMV() {
            PaymentService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                if ((data && !_.isEmpty(data.rechnungsNr))) {
                    vm.meetingData.RechnungsNr = data.rechnungsNr;
                }
                if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                    vm.meetingData.RechnungsNr = data.data.rechnungsNr;
                }
            })
        }

    }]);
